module.exports = __webpack_public_path__ + "img/icon_account_setting.530193ae.svg";